import '../css_styles/button_styles.css'
import '../css_styles/window_canvas_styles.css'

// imports relevant for HTTP calls
import { useAuth0 } from '@auth0/auth0-react';
import DisplayException from '../error_messages/DisplayException';
import CircleLoader from 'react-spinners/CircleLoader';
import { SERVER_URL } from '../config_server_url';

// ----- Imports for main window --------
import Sample from './workflow_elements/Sample'
import { updateCycles_onDeleteElement, updateCycles_onMoveElement, updateCycles_onAddElement } from './workflow_elements/cycle_utils';
import YesNoPopup from '../popup_windows/YesNoPopup';
import InfoPopup from '../popup_windows/InfoPopup';
import InteractiveValidationTable from './InteractiveValidationTable';
import InfoExperimentalProcedure from './InfoExperimentalProcedure';

import UserSessionContext from '../user_session/context_user_session';
import { useContext, useState, useEffect } from 'react';


function WorkflowEditor(props) {

    const { user } = useAuth0();

    const [title, setTitle] = useState('')
    const [descriptionProcedure, setDesciptionProcedure] = useState('<p><em style="color: rgb(127, 127, 127);">Enter details about the experimental procedure ...</em></p>');
    const [workflow, setWorkflow] = useState({samples:[]});
    const [factors, setFactors] = useState([]);
    const [objectives, setObjectives] = useState([]);
    const [goNoGo, setGoNoGo] = useState([]);
    const [modifications, setModifications] = useState(false);
    // monitor modifictations that affect the DesignSpace/Objective -> OnCreateCampaign: if such modifications are detected, Campaing Validation will ask to validate objects DesignSpace/Objective
    // relavant monitored changes:
    // DesignSpace:
    //  * Create New Factor
    // Optional if props.designSpaceListener() -> trigger actions on relevant changes affecting DesignSpace

    // Objective:
    //  * Create New Repsonse
    //  * Create New Go/NoGo
    // Optional if props.objectiveListener() -> trigger actions on relevant changes affecting Objective

    const [majorChangeDesignSpace, setMajorChangeDesignSpace] = useState(false);
    const [majorChangeObjective, setMajorChangeObjective] = useState(false);

    const [showPopup, setShwoPopup] = useState(false);
    const [showCreateSuccess, setShowCreateSuccess] = useState(false);
    const [showUpdateSuccess, setShowUpdateSuccess] = useState(false);
    const [showNoModificationDetected, setShowNoModificationDetected] = useState(false)
    const [triggerSave, setTriggerSave] = useState(0)
    const [createdObjects, setCreatedObjects] = useState(null)
    const sampleTemplate = {name:'', cycles:[], elements:[]};
    const elementTemplate = {name:'', type:'', pins:[]};
    const pinTemplate = {name:''};
    const factorTemplate = {name:'', type:'Continuous', data_type:'Numerical', units:'', range_min:'', range_max:'',  discrete:[], categories:[], remarks:''}
    const segmentTemplate = {type:'Interval', min:'', max:'', val:'', list_vals:[]}
    const segmentTemplateDiscrete = {type:'Discrete', min:'', max:'', val:'', list_vals:[]}
    const objectiveTemplate= {name:'', type:'Continuous', data_type:'Numerical', is_raw:false, is_score:true, scoring_weight:'1', units:'', go_nogo: false, 
                              range_continuous:segmentTemplate, range_discrete:segmentTemplateDiscrete, target:[], no_good:[], okay:[], go_criteria:[], shape_param_continuous:null, remarks:''}
    const cycleTemplate = {cycletime_min:null, cycletime_max:'', cycletime_unit:'', runparallel_min:'', runparallel_max:'', cycle_elements:[]};
    // ------------------ Load User Session Information ---------------------------------
    const usr_session_ctx = useContext(UserSessionContext);
    const [isLoading, setIsLoading] = useState(false);
    // ------------------ Display HTTP/Server Exceptions ---------------------------------
    const [Exception, setException] = useState(false);
    const [ExceptionMessage, setExceptionMessage] = useState('');
    // ------------------ Display Object Validation Information/Warnings/Errors  ---------------------------------
    const [validationWindow, setValidationWindow] = useState(false);
    const [validationMessage, setValidationMessage] = useState([]);

    // If there is an active experimental setup -> then load it
    useEffect(() => {
        // if experimental workflow and associated campaign objects exist -> load these objects
        if (props.campaign_objects?.uuid_experimental_setup !== '' &&
            props.campaign_objects?.uuid_design_space !== '' &&
            props.campaign_objects?.uuid_objective !== '' ) {
            setIsLoading(true);
            fetch(`${SERVER_URL}/current_project/load_campaign_objects/`, {method: 'POST',
                                                            headers:{'Content-Type':'application/json',
                                                                     'uuid_tenant': usr_session_ctx.uuid_tenant},
                                                            body:JSON.stringify(props.campaign_objects)})
            .then((res) => {
                if(!res.ok) {
                    throw new Error(`HTTP error ${res.status}`);
                }
                return res.json();
            })
            .then((data) => {
                setWorkflow(data.data.exp_setup.workflow);
                if (data.data.exp_setup.description !== ''){
                    setDesciptionProcedure(data.data.exp_setup.description);
                }
                setTitle(data.data.exp_setup.title);
                setFactors(data.data.design_space.factors)
                setObjectives(data.data.objective.objectives)
                let go_nogo = []
                data.data.objective.objectives.forEach( (objective, id) => {
                    if(objective.go_nogo === true){ go_nogo.push(objective.name); }
                });
                setGoNoGo(go_nogo);
                setIsLoading(false); 
            })
            .catch((err) => {
                setException(true);
                setExceptionMessage(`HTTPException: err_msg=${err.message}`);
            });
        }
    }, []);

    // ------------- Handle Title --------------------------

    function handleTitle(event){
        setTitle(event.target.value);
        setModifications(true);
    }

    // ------------ Functions to Handle Samples --------------------------
    function handleCreateSample() {
        const updatedSamples = [...workflow.samples, sampleTemplate];
        const updatedWorkflow = {...workflow, samples: updatedSamples};
        setWorkflow(updatedWorkflow);
        setModifications(true);
    }

    function handleSampleName(event) {
        let parser = event.target.id.split('_');
        let sample_id = parseInt(parser[1]);
        const updatedSamples = [...workflow.samples];
        updatedSamples[sample_id] = {...updatedSamples[sample_id],
                                        name: event.target.value };
        const updatedWorkflow = {...workflow, samples: updatedSamples};
        setWorkflow(updatedWorkflow);
        setModifications(true);
    }

    function handleRemoveSample(event) {
        let parser = event.target.id.split('_');
        let sample_id = parseInt(parser[1]);
        let updatedSamples = [...workflow.samples]
        // onDeleteSample -> update factors and objectives 
        let factor_id = firstPin2ListId(sample_id, 0, 'Process')
        let updatedFactors = [];
        let objective_id = firstPin2ListId(sample_id, 0, 'Measurement')
        let updatedObjectives = [];
        let gonogo_id = firstPin2ListId(sample_id, 0, 'GoNoGo')
        let updatedGoNoGo = [];
        // if last sample
        if(sample_id === workflow.samples.length -1 ){
            updatedFactors = [...factors.slice(0,factor_id)];
            updatedObjectives = [...objectives.slice(0,objective_id)];
            updatedGoNoGo = [...goNoGo.slice(0,gonogo_id)];
        }
        else {
            let factor_id_next = firstPin2ListId(sample_id+1, 0, 'Process')
            updatedFactors = [...factors.slice(0,factor_id), ...factors.slice(factor_id_next)];
            let objective_id_next = firstPin2ListId(sample_id+1, 0, 'Measurement')
            updatedObjectives = [...objectives.slice(0,objective_id), ...objectives.slice(objective_id_next)];
            // handle goNoGo
            let gonogo_id_next = firstPin2ListId(sample_id+1, 0, 'GoNoGo')
            updatedGoNoGo = [...goNoGo.slice(0,gonogo_id), ...goNoGo.slice(gonogo_id_next)];
        }
        // handle update goNoGo in objectives
        updatedObjectives.forEach((objective, id) => {
            if (updatedGoNoGo.includes(updatedObjectives[id].name)){
                updatedObjectives[id].go_nogo = true;
            }
            else {
                updatedObjectives[id].go_nogo = false;
            }
        });

        setFactors(updatedFactors);
        setGoNoGo(updatedGoNoGo);
        setObjectives(updatedObjectives);
       
        updatedSamples = updatedSamples.filter((_, index) => index !== sample_id);
        const updatedWorkflow = {...workflow, samples: updatedSamples};
        setWorkflow(updatedWorkflow);
        setModifications(true);
    }

    // ------------ Functions to Handle Sample Elements --------------------------

    function handleAddElement(event){
        // supported Element Types: Process, Measurement, GoNoGo
        let parser = event.target.id.split('_');
        let sample_id = parseInt(parser[2]);
        let element_type = parser[1];
        const updatedSamples = [...workflow.samples];
        const new_element = { ...elementTemplate, type: element_type };
        updatedSamples[sample_id] = {...updatedSamples[sample_id],
                                        elements: [...updatedSamples[sample_id].elements, new_element]};
        const updatedCycles = updateCycles_onAddElement(updatedSamples[sample_id].elements, 
                                                        updatedSamples[sample_id].cycles, 
                                                        cycleTemplate);
        updatedSamples[sample_id] = {...updatedSamples[sample_id], cycles: updatedCycles };
        const updatedWorkflow = { ...workflow, samples: updatedSamples };
        setWorkflow(updatedWorkflow);
        setModifications(true);
    }
    

    function handleDeleteElement(event){
        // supported Element Types: Process, Measurement, GoNoGo
        let parser = event.target.id.split('_');
        let sample_id = parseInt(parser[2]);
        let element_id = parseInt(parser[3]);
        if(workflow.samples[sample_id].elements[element_id].type === 'Process')
        {
            // remove elements from factors, if element===Process has pins that are deleted together with the element
            let factor_id = firstPin2ListId(sample_id, element_id, 'Process');
            let num_pins = workflow.samples[sample_id].elements[element_id].pins.length;
            const updatedFactors = [...factors.slice(0,factor_id), 
                                    ...factors.slice(factor_id+num_pins)];
            setFactors(updatedFactors);
        }
        if(workflow.samples[sample_id].elements[element_id].type === 'Measurement')
        {
            // remove elements from objectives, if element===Measurement has pins that are deleted together with the element
            let objective_id = firstPin2ListId(sample_id, element_id, 'Measurement');
            let num_pins = workflow.samples[sample_id].elements[element_id].pins.length;
            const updatedObjectives = [...objectives.slice(0, objective_id), 
                                       ...objectives.slice(objective_id+num_pins)];
            setObjectives(updatedObjectives);
        }
        if(workflow.samples[sample_id].elements[element_id].type === 'GoNoGo')
        {
            // remove elements from goNoGo, if element===GoNoGo has pins that are deleted together with the element
            let gonogo_id = firstPin2ListId(sample_id, element_id, 'GoNoGo');
            let num_pins = workflow.samples[sample_id].elements[element_id].pins.length;
            const updatedGoNoGo = [...goNoGo.slice(0, gonogo_id), 
                                       ...goNoGo.slice(gonogo_id+num_pins)];
            // handle update goNoGo in objectives
            const updatedObjectives = [...objectives];
            updatedObjectives.forEach((objective, id) => {
                if (updatedGoNoGo.includes(updatedObjectives[id].name)){
                    updatedObjectives[id].go_nogo = true;
                }
                else {
                    updatedObjectives[id].go_nogo = false;
                }
            });
            setGoNoGo(updatedGoNoGo);
            setObjectives(updatedObjectives);
        }
        const updatedSamples = [...workflow.samples];
        updatedSamples[sample_id].elements = updatedSamples[sample_id].elements.filter((_, index) => index !== element_id);
        const updatedCycles = updateCycles_onDeleteElement(updatedSamples[sample_id].elements, 
                                                           updatedSamples[sample_id].cycles, 
                                                           element_id,
                                                           cycleTemplate);
        updatedSamples[sample_id] = {...updatedSamples[sample_id], cycles: updatedCycles };
        const updatedWorkflow = { ...workflow, samples: updatedSamples };
        setWorkflow(updatedWorkflow);
        setModifications(true);
    }

    function handleElementName(event) {
        let parser = event.target.id.split('_');
        let sample_id = parseInt(parser[2]);
        let element_id = parseInt(parser[3]);
        const updatedSamples = [...workflow.samples];
        updatedSamples[sample_id].elements[element_id].name = event.target.value;
        const updatedWorkflow = { ...workflow, samples: updatedSamples };
        setWorkflow(updatedWorkflow);
        setModifications(true);
    }


    function handleMoveLeft(event){
        let parser = event.target.id.split('_');
        let sample_id = parseInt(parser[2]);
        let element_id = parseInt(parser[3]);

        if(workflow.samples[sample_id].elements[element_id].type === 'Process' && workflow.samples[sample_id].elements[element_id-1].type === 'Process')
        {
            // if two process blocks are swaped, then we need to update the state variable factors
            let factor_id = firstPin2ListId(sample_id, element_id, 'Process');
            let factor_id_left = firstPin2ListId(sample_id, element_id-1, 'Process');
            let num_pins = workflow.samples[sample_id].elements[element_id].pins.length;
            let num_pins_left = workflow.samples[sample_id].elements[element_id-1].pins.length;
            const updatedFactors = [...factors.slice(0,factor_id_left), 
                                    ...factors.slice(factor_id, factor_id+num_pins), 
                                    ...factors.slice(factor_id_left, factor_id_left+num_pins_left),
                                    ...factors.slice(factor_id+num_pins)];
            setFactors(updatedFactors);
        }

        if(workflow.samples[sample_id].elements[element_id].type === 'Measurement' && workflow.samples[sample_id].elements[element_id-1].type === 'Measurement')
        {
            // if two process blocks are swaped, then we need to update the state variable factors
            let objective_id = firstPin2ListId(sample_id, element_id, 'Measurement');
            let objective_id_left = firstPin2ListId(sample_id, element_id-1, 'Measurement');
            let num_pins = workflow.samples[sample_id].elements[element_id].pins.length;
            let num_pins_left = workflow.samples[sample_id].elements[element_id-1].pins.length;
            const updatedObjectives = [...objectives.slice(0,objective_id_left), 
                                       ...objectives.slice(objective_id, objective_id+num_pins), 
                                       ...objectives.slice(objective_id_left, objective_id_left+num_pins_left),
                                       ...objectives.slice(objective_id+num_pins)];
            setObjectives(updatedObjectives);
        }

        if(workflow.samples[sample_id].elements[element_id].type === 'GoNoGo' && workflow.samples[sample_id].elements[element_id-1].type === 'GoNoGo')
        {
            // if two process blocks are swaped, then we need to update the state variable factors
            let gonogo_id = firstPin2ListId(sample_id, element_id, 'GoNoGo');
            let gonogo_id_left = firstPin2ListId(sample_id, element_id-1, 'GoNoGo');
            let num_pins = workflow.samples[sample_id].elements[element_id].pins.length;
            let num_pins_left = workflow.samples[sample_id].elements[element_id-1].pins.length;
            const updatedGoNoGo = [...goNoGo.slice(0,gonogo_id_left), 
                                       ...goNoGo.slice(gonogo_id, gonogo_id+num_pins), 
                                       ...goNoGo.slice(gonogo_id_left, gonogo_id_left+num_pins_left),
                                       ...goNoGo.slice(gonogo_id+num_pins)];
            setGoNoGo(updatedGoNoGo);
        }
      
        const updatedSamples = [...workflow.samples];
        const updatedElements = [...updatedSamples[sample_id].elements];
        const tmp = updatedElements[element_id];
        updatedElements[element_id] = updatedElements[element_id - 1];
        updatedElements[element_id - 1] = tmp;
        updatedSamples[sample_id].elements = updatedElements;
        const updatedCycles = updateCycles_onMoveElement(updatedSamples[sample_id].elements, 
                                                         updatedSamples[sample_id].cycles,
                                                         element_id-1, 
                                                         element_id,
                                                         cycleTemplate
                                                        );
        updatedSamples[sample_id] = {...updatedSamples[sample_id], cycles: updatedCycles };
        const updatedWorkflow = { ...workflow, samples: updatedSamples };
        setWorkflow(updatedWorkflow);
        setModifications(true);
    }  

    function handleMoveRight(event){
        let parser = event.target.id.split('_');
        let sample_id = parseInt(parser[2]);
        let element_id = parseInt(parser[3]);

        if(workflow.samples[sample_id].elements[element_id].type === 'Process' && workflow.samples[sample_id].elements[element_id+1].type === 'Process')
        {
            // if two process blocks are swaped, then we need to update the state variable factors
            let factor_id = firstPin2ListId(sample_id, element_id, 'Process');
            let factor_id_right = firstPin2ListId(sample_id, element_id+1, 'Process');
            let num_pins = workflow.samples[sample_id].elements[element_id].pins.length;
            let num_pins_right = workflow.samples[sample_id].elements[element_id+1].pins.length;
            const updatedFactors = [...factors.slice(0,factor_id), 
                                    ...factors.slice(factor_id_right, factor_id_right+num_pins_right), 
                                    ...factors.slice(factor_id, factor_id+num_pins),
                                    ...factors.slice(factor_id_right+num_pins_right)];
            setFactors(updatedFactors);
        }

        if(workflow.samples[sample_id].elements[element_id].type === 'Measurement' && workflow.samples[sample_id].elements[element_id+1].type === 'Measurement')
        {
            // if two process blocks are swaped, then we need to update the state variable factors
            let objective_id = firstPin2ListId(sample_id, element_id, 'Measurement');
            let objective_id_right = firstPin2ListId(sample_id, element_id+1, 'Measurement');
            let num_pins = workflow.samples[sample_id].elements[element_id].pins.length;
            let num_pins_right = workflow.samples[sample_id].elements[element_id+1].pins.length;
            const updatedObjectives = [...objectives.slice(0, objective_id), 
                                       ...objectives.slice(objective_id_right, objective_id_right+num_pins_right), 
                                       ...objectives.slice(objective_id, objective_id+num_pins),
                                       ...objectives.slice(objective_id_right+num_pins_right)];
            setObjectives(updatedObjectives);
        }

        if(workflow.samples[sample_id].elements[element_id].type === 'GoNoGo' && workflow.samples[sample_id].elements[element_id+1].type === 'GoNoGo')
        {
            // if two process blocks are swaped, then we need to update the state variable factors
            let gonogo_id = firstPin2ListId(sample_id, element_id, 'GoNoGo');
            let gonogo_id_right = firstPin2ListId(sample_id, element_id+1, 'GoNoGo');
            let num_pins = workflow.samples[sample_id].elements[element_id].pins.length;
            let num_pins_right = workflow.samples[sample_id].elements[element_id+1].pins.length;
            const updatedGoNoGo = [...goNoGo.slice(0, gonogo_id), 
                                   ...goNoGo.slice(gonogo_id_right, gonogo_id_right+num_pins_right), 
                                   ...goNoGo.slice(gonogo_id, gonogo_id+num_pins),
                                   ...goNoGo.slice(gonogo_id_right+num_pins_right)];
            setGoNoGo(updatedGoNoGo);
        }
        const updatedSamples = [...workflow.samples];
        const updatedElements = [...updatedSamples[sample_id].elements]; 
        const tmp = updatedElements[element_id];
        updatedElements[element_id] = updatedElements[element_id + 1];
        updatedElements[element_id + 1] = tmp;
        updatedSamples[sample_id].elements = updatedElements;
        const updatedCycles = updateCycles_onMoveElement(updatedSamples[sample_id].elements, 
                                                         updatedSamples[sample_id].cycles,
                                                         element_id, 
                                                         element_id+1,
                                                         cycleTemplate);
        updatedSamples[sample_id] = {...updatedSamples[sample_id], cycles: updatedCycles };
        const updatedWorkflow = { ...workflow, samples: updatedSamples };
        setWorkflow(updatedWorkflow);
        setModifications(true);
    }  

    // ------------ Functions to Handle Sample Elements Pins  --------------------------
    function handleAddPin(event) {
        let parser = event.target.id.split('_');
        let sample_id = parseInt(parser[2]);
        let element_id = parseInt(parser[3]);
        if(workflow.samples[sample_id].elements[element_id].type==='Process'){
            let factor_id = firstPin2ListId(sample_id, element_id, 'Process')+workflow.samples[sample_id].elements[element_id].pins.length;    
            const updatedFactors = [...factors];
            updatedFactors.splice(factor_id, 0, factorTemplate);
            setMajorChangeDesignSpace(true);
            if(props.designSpaceListener) {props.designSpaceListener();}
            setFactors(updatedFactors);
        }
        if(workflow.samples[sample_id].elements[element_id].type==='Measurement'){
            let objective_id = firstPin2ListId(sample_id, element_id, 'Measurement')+workflow.samples[sample_id].elements[element_id].pins.length;    
            const updatedObjectives = [...objectives];
            updatedObjectives.splice(objective_id, 0, objectiveTemplate);
            setMajorChangeObjective(true);
            if(props.objectiveListener) {props.objectiveListener();}
            setObjectives(updatedObjectives);
        }

        if(workflow.samples[sample_id].elements[element_id].type==='GoNoGo'){
            let gonogo_id = firstPin2ListId(sample_id, element_id, 'GoNoGo')+workflow.samples[sample_id].elements[element_id].pins.length;    
            const updatedGoNoGo = [...goNoGo];
            updatedGoNoGo.splice(gonogo_id, 0, '');
            setMajorChangeObjective(true);
            setGoNoGo(updatedGoNoGo);
        }

        const updatedSamples = [...workflow.samples];
        const updatedElements = [...updatedSamples[sample_id].elements];
        updatedElements[element_id] = {...updatedElements[element_id], pins: [...updatedElements[element_id].pins, pinTemplate] };
        updatedSamples[sample_id] = { ...updatedSamples[sample_id], elements: updatedElements };
        const updatedWorkflow = { ...workflow, samples: updatedSamples };
        setWorkflow(updatedWorkflow);
        setModifications(true);
    }

    function handleRemovePin(event) {
        let parser = event.target.id.split('_');
        let sample_id = parseInt(parser[2]);
        let element_id = parseInt(parser[3]);
        let pin_id = parseInt(parser[4]);
        if(workflow.samples[sample_id].elements[element_id].type==='Process'){
            let factor_id = firstPin2ListId(sample_id, element_id, 'Process')+pin_id;    
            const updatedFactors = factors.filter((_, index) => index !== factor_id);
            setFactors(updatedFactors);
        }

        if(workflow.samples[sample_id].elements[element_id].type==='Measurement'){
            let objective_id = firstPin2ListId(sample_id, element_id, 'Measurement')+pin_id;    
            const updatedObjectives = objectives.filter((_, index) => index !== objective_id);
            setObjectives(updatedObjectives);
        }

        if(workflow.samples[sample_id].elements[element_id].type==='GoNoGo'){
            let gonogo_id = firstPin2ListId(sample_id, element_id, 'GoNoGo')+pin_id;    
            const updatedGoNoGo = goNoGo.filter((_, index) => index !== gonogo_id);
            // handle update goNoGo in objectives
            const updatedObjectives = [...objectives];
            updatedObjectives.forEach((objective, id) => {
                if (updatedGoNoGo.includes(updatedObjectives[id].name)){
                        updatedObjectives[id].go_nogo = true;
                }
                else {
                        updatedObjectives[id].go_nogo = false;
                }
            });
            setObjectives(updatedObjectives);
            setGoNoGo(updatedGoNoGo);
        }
        const updatedSamples = [...workflow.samples];
        updatedSamples[sample_id].elements[element_id].pins = updatedSamples[sample_id].elements[element_id].pins.filter((_, index) => index !== pin_id);
        const updatedWorkflow = { ...workflow, samples: updatedSamples };
        setWorkflow(updatedWorkflow);
        setModifications(true);
    }


    function handlePinName(event) {
        let parser = event.target.id.split('_');
        let sample_id = parseInt(parser[2]);
        let element_id = parseInt(parser[3]);
        let pin_id = parseInt(parser[4]);
        if(workflow.samples[sample_id].elements[element_id].type==='Process'){
            let factor_id = firstPin2ListId(sample_id, element_id, 'Process')+pin_id;
            const updatedFactors = [...factors];
            updatedFactors[factor_id] = {...updatedFactors[factor_id], name: event.target.value}
            setFactors(updatedFactors);
        }
        if(workflow.samples[sample_id].elements[element_id].type==='Measurement'){
            let objective_id = firstPin2ListId(sample_id, element_id, 'Measurement')+pin_id;
            const updatedObjectives = [...objectives];
            updatedObjectives[objective_id] = {...updatedObjectives[objective_id], name: event.target.value}
            updatedObjectives.forEach((objective, id) => {
                if (goNoGo.includes(updatedObjectives[id].name)){
                        updatedObjectives[id].go_nogo = true;
                }
                else {
                        updatedObjectives[id].go_nogo = false;
                }
            });
            setObjectives(updatedObjectives);
        }
        if(workflow.samples[sample_id].elements[element_id].type==='GoNoGo'){
            let gonogo_id = firstPin2ListId(sample_id, element_id, 'GoNoGo')+pin_id;
            const updatedGoNoGo = [...goNoGo];
            updatedGoNoGo[gonogo_id] = event.target.value;
            // handle update goNoGo in objectives
            const updatedObjectives = [...objectives];
            updatedObjectives.forEach((objective, id) => {
                if (updatedGoNoGo.includes(updatedObjectives[id].name)){
                        updatedObjectives[id].go_nogo = true;
                }
                else {
                        updatedObjectives[id].go_nogo = false;
                }
            });
            setObjectives(updatedObjectives);
            setGoNoGo(updatedGoNoGo);
        }
        const updatedSamples = [...workflow.samples];
        updatedSamples[sample_id].elements[element_id].pins[pin_id] = {
            ...updatedSamples[sample_id].elements[element_id].pins[pin_id],
            name: event.target.value
          };
        const updatedWorkflow = { ...workflow, samples: updatedSamples };
        setWorkflow(updatedWorkflow);
        setModifications(true);
    }


    // ------------ Functions to Handle Cycle Data  --------------------------
    function handleCycleInfo(event){
        let parser = event.target.id.split('_');
        let key = parser[0]+'_'+parser[1];
        let sample_id = parseInt(parser[2]);
        let cycle_id = parseInt(parser[3]);
        let value = event.target.value;
        if (key !== 'cycletime_unit'){
            if(value !== ''){
                value = parseFloat(value);
                if( key === 'runparallel_min' || key === 'runparallel_max'){
                    value = Math.floor(parseFloat(value));
                }
                value = String(value);
                if (value<0) { value='';}
            }
        }
        const updatedSamples = [...workflow.samples];
        updatedSamples[sample_id].cycles[cycle_id] = {...updatedSamples[sample_id].cycles[cycle_id], [key]: value };
        const updatedWorkflow = { ...workflow, samples: updatedSamples };
        setWorkflow(updatedWorkflow);
        setModifications(true);

    }

    // ------------ Utility Functions ---------------------------
    function firstPin2ListId(target_sample_id, target_element_id, element_type){
        // returns the factorId of the first pin of target_element_id in target_sample_id
        let list_id = 0 
        const all_samples = workflow.samples;
        // go through all previous samples
        for(let i=0; i<target_sample_id; i++){
            let elements = all_samples[i].elements; 
            for(let j=0; j<elements.length; j++){
                if(elements[j].type===element_type){
                    list_id += elements[j].pins.length;
                }
            }
        }
        // go through all elements of target_sample until target_element_id
        let elements = all_samples[target_sample_id].elements; 
        for(let j=0; j<target_element_id; j++){
            if(elements[j].type===element_type){
                list_id += elements[j].pins.length;
            }
        }
        return list_id
    }

    

    function FactorId2SampleElementPinID(factor_id){
        // returns the sample_id, element_id, pin_id of the corresponding factor with id=factor_id
        let count_factors = 0;
        const all_samples = workflow.samples;
        const num_samples = all_samples.length;
        for(let i=0; i<num_samples; i++){
            const sample = all_samples[i];
            const num_elements = sample.elements.length;
            for(let j=0; j<num_elements; j++){
                const element=sample.elements[j];
                if (element.type==='Process')
                {
                    const num_pins = element.pins.length;
                    for(let k=0; k<num_pins; k++){
                        if(count_factors === factor_id)
                        {
                            let sample_id = i;
                            let element_id = j;
                            let pin_id = k;
                            return [sample_id, element_id, pin_id]
                        }
                        count_factors +=1;
                    }
                }
            }
        }
    }

    function ResponseId2SampleElementPinID(response_id){
        // returns the sample_id, element_id, pin_id of the corresponding response with id=response_id
        let count_responses = 0;
        const all_samples = workflow.samples;
        const num_samples = all_samples.length;
        for(let i=0; i<num_samples; i++){
            const sample = all_samples[i];
            const num_elements = sample.elements.length;
            for(let j=0; j<num_elements; j++){
                const element=sample.elements[j];
                if (element.type==='Measurement')
                {
                    const num_pins = element.pins.length;
                    for(let k=0; k<num_pins; k++){
                        if(count_responses === response_id)
                        {
                            let sample_id = i;
                            let element_id = j;
                            let pin_id = k;
                            return [sample_id, element_id, pin_id]
                        }
                        count_responses +=1;
                    }
                }
            }
        }
    }


    function GoNoGoId2SampleElementPinID(gonogo_id){
        // returns the sample_id, element_id, pin_id of the corresponding response with id=response_id
        let count_gonogos = 0;
        const all_samples = workflow.samples;
        const num_samples = all_samples.length;
        for(let i=0; i<num_samples; i++){
            const sample = all_samples[i];
            const num_elements = sample.elements.length;
            for(let j=0; j<num_elements; j++){
                const element=sample.elements[j];
                if (element.type==='GoNoGo')
                {
                    const num_pins = element.pins.length;
                    for(let k=0; k<num_pins; k++){
                        if(count_gonogos === gonogo_id)
                        {
                            let sample_id = i;
                            let element_id = j;
                            let pin_id = k;
                            return [sample_id, element_id, pin_id]
                        }
                        count_gonogos +=1;
                    }
                }
            }
        }
    }
    
    
    // ------------ Functions to Handle Save Experimental Setup --------------------------
    async function handleSave() {
        if (modifications === false ) {
            setShowNoModificationDetected(true);
            return;
        }
        setIsLoading(true);
        let data_exp_setup = { title: title, description:descriptionProcedure, workflow: workflow};
        let data_design_space = { factors: factors }
        let data_objective = {objectives: objectives }
        let data_gonogo = {gonogos: goNoGo}
        
        try{
            let response1 = null;
            // if experimental setup does not yet exist 
            //    -> create campaign objects Experimental Workflow, Design Space, Objective
            if(props.campaign_objects.uuid_experimental_setup === '' && !createdObjects)
            {
                let headers = {
                    'Content-Type': 'application/json',
                    'auth0_user': user.sub,
                    'uuid_tenant': usr_session_ctx.uuid_tenant
                };
                let uuid_project = usr_session_ctx.session_info.uuid_current_project;
                let data_campaign_objects ={uuid_project: uuid_project,
                                            exp_setup: data_exp_setup,
                                            design_space: data_design_space,
                                            objective: data_objective,
                                            gonogo: data_gonogo }
                response1 = await fetch(`${SERVER_URL}/current_project/initialize_campaign_objects/`, {
                    method: 'POST',
                    headers: headers,
                    body: JSON.stringify(data_campaign_objects)
                });
            }
            if(props.campaign_objects.uuid_experimental_setup === '' && createdObjects)
                {
                    let headers = {
                        'Content-Type': 'application/json',
                        'uuid_tenant': usr_session_ctx.uuid_tenant
                    };
                    let uuid_campaign_objects = { uuid_exp_setup: createdObjects.uuid_exp_setup,
                                                  uuid_design_space: createdObjects.uuid_design_space,
                                                  uuid_objective: createdObjects.uuid_objective };
    
                    let data_campaign_objects ={ uuid_campaign_objects: uuid_campaign_objects,
                                                 exp_setup: data_exp_setup,
                                                 design_space: data_design_space,
                                                 objective: data_objective,
                                                 gonogo: data_gonogo };
                    response1 = await fetch(`${SERVER_URL}/current_project/update_campaign_objects/`, {
                        method: 'POST',
                        headers: headers,
                        body: JSON.stringify(data_campaign_objects)
                    });
                }
            if(props.campaign_objects.uuid_experimental_setup !== '')
            {
                let headers = {
                    'Content-Type': 'application/json',
                    'uuid_tenant': usr_session_ctx.uuid_tenant
                };
                let uuid_campaign_objects = { uuid_exp_setup: props.campaign_objects.uuid_experimental_setup,
                                              uuid_design_space: props.campaign_objects.uuid_design_space,
                                              uuid_objective: props.campaign_objects.uuid_objective };

                let data_campaign_objects ={ uuid_campaign_objects: uuid_campaign_objects,
                                             exp_setup: data_exp_setup,
                                             design_space: data_design_space,
                                             objective: data_objective,
                                             gonogo: data_gonogo };
                response1 = await fetch(`${SERVER_URL}/current_project/update_campaign_objects/`, {
                    method: 'POST',
                    headers: headers,
                    body: JSON.stringify(data_campaign_objects)
                });
            }
            if(response1.ok){
                const data1 = await response1.json();
                if(data1.msg === 'ok'){
                    setModifications(false);
                    // update SessionInfo - on objects create; ExperimentalSetup is validated; DesignSpace and Objectives are not yet validated
                    if (props.handleSessionUpdate ){ 
                        props.handleSessionUpdate(majorChangeDesignSpace, majorChangeObjective, data1.data)
                     }

                    if(props.changeDesignSpaceListener) {props.changeDesignSpaceListener(majorChangeDesignSpace);}
                    if(props.changeObjectiveListener) {props.changeObjectiveListener(majorChangeObjective);}
                    setMajorChangeDesignSpace(false);
                    setMajorChangeObjective(false);
                    // if objects did not exist and were created:
                    if(props.campaign_objects.uuid_experimental_setup === '' && !createdObjects){
                        setShowCreateSuccess(true);
                        setCreatedObjects( {uuid_exp_setup: data1.data.uuid_exp_setup,
                                            uuid_design_space:data1.data.uuid_design_space,
                                            uuid_objective: data1.data.uuid_objective} )
                    }
                    else{ 
                        setShowUpdateSuccess(true);
                    }
                }
                else {
                    setValidationMessage(data1.msg)
                    setValidationWindow(true)
                }
            }
            if(!response1.ok){
                throw new Error(`HTTP error ${response1.status}`);
            }
            setIsLoading(false);
        } catch(err) {
            setIsLoading(false);
            setException(true);
            setExceptionMessage(`HTTPException: err_msg=${err.message}`);
        }
    }

    function handleExit(){
        if(modifications===true) {
            setShwoPopup('true');
        }
        else{
            props.exit();
        }
    }

    // ------------ Functions to Handle input validation ----------------------------
    function handleFactorValidation(event){
        let parser = event.target.id.split('_');
        let factor_id = parseInt(parser[2]);
        const updatedFactorNameFixes = [...validationMessage.factor_name_fixes];
        updatedFactorNameFixes[factor_id] = {...updatedFactorNameFixes[factor_id], new_name: event.target.value };
        const updatedValidationMessage = { ...validationMessage, factor_name_fixes: updatedFactorNameFixes };
        setValidationMessage(updatedValidationMessage)
    }

    function handleObjectiveValidation(event){
        let parser = event.target.id.split('_');
        let objective_id = parseInt(parser[2]);
        const updatedObjectiveNameFixes = [...validationMessage.objective_name_fixes];
        updatedObjectiveNameFixes[objective_id] = {...updatedObjectiveNameFixes[objective_id], new_name: event.target.value };
        const updatedValidationMessage = { ...validationMessage, objective_name_fixes: updatedObjectiveNameFixes };
        setValidationMessage(updatedValidationMessage)
    }

    function handleGoNoGoValidation(event){
        let parser = event.target.id.split('_');
        let gonogo_id = parseInt(parser[2]);
        const updatedGoNoGoNameFixes = [...validationMessage.gonogo_name_fixes];
        updatedGoNoGoNameFixes[gonogo_id] = {...updatedGoNoGoNameFixes[gonogo_id], new_name: event.target.value };
        const updatedValidationMessage = { ...validationMessage, gonogo_name_fixes: updatedGoNoGoNameFixes };
        setValidationMessage(updatedValidationMessage)
    }

    function handleExitValidation(){
        setValidationMessage([]);
        setValidationWindow(false);
    }

    function handleSaveValidationFactorObjectives(){
        const updatedSamples = [...workflow.samples];
        if(validationMessage.status_factors==='invalid'){
            const updatedFactors = [...factors]
            const factorNameFixes = [...validationMessage.factor_name_fixes] 
            updatedFactors.forEach((factor, id) => {
                const updatedFactor = {...factor, name: factorNameFixes[id].new_name};
                updatedFactors[id] = updatedFactor;
                const parser = FactorId2SampleElementPinID(id);
                const sample_id = parser[0];
                const element_id = parser[1];
                const pin_id = parser[2];
                updatedSamples[sample_id].elements[element_id].pins[pin_id] = {
                    ...updatedSamples[sample_id].elements[element_id].pins[pin_id],
                    name: factorNameFixes[id].new_name
                  };
            });
            setFactors(updatedFactors);
        }
        if(validationMessage.status_objectives==='invalid'){
            const updatedObjectives = [...objectives]
            const objectiveNameFixes = [...validationMessage.objective_name_fixes] 
            updatedObjectives.forEach((objective, id) => {
                const updatedObjective = {...objective, name: objectiveNameFixes[id].new_name};
                updatedObjectives[id] = updatedObjective;
                const parser = ResponseId2SampleElementPinID(id);
                const sample_id = parser[0];
                const element_id = parser[1];
                const pin_id = parser[2];
                updatedSamples[sample_id].elements[element_id].pins[pin_id] = {
                    ...updatedSamples[sample_id].elements[element_id].pins[pin_id],
                    name: objectiveNameFixes[id].new_name
                  };
            });
            setObjectives(updatedObjectives);
        }
        const updatedWorkflow = { ...workflow, samples: updatedSamples };
        setWorkflow(updatedWorkflow);
        setValidationMessage([]);
        setValidationWindow(false);
        // We cannot directly call handleSave since the states for factors, objectives, are not yet updated by react
        //handleSave()
        // we will useEffect() function call that will be triggered by changes of state triggerSave
        setTriggerSave(triggerSave+1);
    }

    function handleSaveValidationGoNoGo(){
        const updatedSamples = [...workflow.samples];
        const updatedGoNoGo = [...goNoGo]
        const gonogoNameFixes = [...validationMessage.gonogo_name_fixes] 
        gonogoNameFixes.forEach((gonogo, id) => {
            updatedGoNoGo[id] = gonogoNameFixes[id].new_name;
            const parser = GoNoGoId2SampleElementPinID(id);
            const sample_id = parser[0];
            const element_id = parser[1];
            const pin_id = parser[2];
            updatedSamples[sample_id].elements[element_id].pins[pin_id] = {
                ...updatedSamples[sample_id].elements[element_id].pins[pin_id],
                name: gonogoNameFixes[id].new_name
                };
        });
        // handle update goNoGo in objectives
        const updatedObjectives = [...objectives];
        updatedObjectives.forEach((objective, id) => {
            if (updatedGoNoGo.includes(updatedObjectives[id].name)){
                    updatedObjectives[id].go_nogo = true;
            }
            else {
                    updatedObjectives[id].go_nogo = false;
            }
        });
        setObjectives(updatedObjectives);
        setGoNoGo(updatedGoNoGo);
        const updatedWorkflow = { ...workflow, samples: updatedSamples };
        setWorkflow(updatedWorkflow);
        setValidationMessage([]);
        setValidationWindow(false);
        // We cannot directly call handleSave since the states for factors, objectives, are not yet updated by react
        //handleSave()
        // we will useEffect() function call that will be triggered by changes of state triggerSave
        setTriggerSave(triggerSave+1);
    }

    useEffect(() => {
        // Make sure this is not called on first render
        if(triggerSave>0){
            handleSave();
        }
    }, [triggerSave])


    function handleQillDescription(html) {
        setDesciptionProcedure(html);
        setModifications(true);
    }



    // ------------ Functions to Handle yes/no Popup window  --------------------------
    function onNo(){
        setShwoPopup(false);
    }

    function onYes(){
        props.exit();
    }

    function onOkCreate(){
        setShowCreateSuccess(false);
    }
    function onOkUpdate(){
        setShowUpdateSuccess(false);
    }
    function onOkNoModifications(){
        setShowNoModificationDetected(false);
    }


    let samples = workflow.samples.map((sample, sampleIndex) => (
        <Sample sid={`${sampleIndex}`}
                key={`${sampleIndex}`}
                handleSampleName={handleSampleName}
                addBlock={handleAddElement}
                remove={handleRemoveSample}
                handleElementName={handleElementName}
                handleDeleteElement={handleDeleteElement}
                handleMoveLeft={handleMoveLeft}
                handleMoveRight={handleMoveRight}
                handleAddPin={handleAddPin}
                handlePinName={handlePinName}
                handleRemovePin={handleRemovePin}
                handleCycleInfo={handleCycleInfo}
                sample={sample}/>
        ));

    let editor = (<></>)
    if(isLoading && !Exception){
        editor = (<div className = {'builder_canvas'} style={{height:props.height}} >
                    <div style = {{position:'absolute', top:'5px', display: 'flex', justifyContent: 'center', alignItems: 'center',  width:'100%', height:'100%'}}>
                        <CircleLoader loading={isLoading} size={40} color='var(--aixelo-green)' />
                    </div>
                </div>);
    }

    if(Exception){
        editor = (<>
                    <div className = {'builder_canvas'} style={{height:props.height}} >
                        <DisplayException>
                            {ExceptionMessage}
                        </DisplayException>  
                    </div>
                </>);
    }

    if(validationWindow) {
        let available_responses = [];
        objectives.forEach((objective, id) => {
            if(objectives[id].name !=='')
                {
                    available_responses.push(objectives[id].name);
                }
        });
        available_responses = [...new Set(available_responses)];
        let no_responses = false;
        if(available_responses.length===0){
            available_responses=['no response available'];
            no_responses = true;
        }
        let action_panel = (
                            <>
                                <div style={{marginTop:'25px'}}>
                                    <div style={{marginLeft:'20px', marginBottom:'5px', fontSize:'14px'}}>Feel free to click 'Exit' to fix inconsistencies directly in Experimental Workflow Editor.</div>
                                    <div style={{display:'flex', margin:'0px'}}>
                                        <button className={'actionButtonSmall'} style={{marginLeft: '20px', right: '0px', marginBottom:'10px'}} onClick={handleSaveValidationFactorObjectives}>Save</button>
                                        <button className={'actionButtonSmall'} style={{marginLeft: '0px', right: '0px', marginBottom:'10px'}} onClick={handleExitValidation}>Exit</button>
                                    </div>
                                </div>
                            </>
                            );

        let show_validations = []
        if(validationMessage.status_factors !=='ok' ){
            show_validations.push(
                <>
                    <h4 style={{marginLeft:'20px', marginBottom:'10px', marginTop:'25px', padding:'0px'}}>Factor names need to be defined and unique</h4>
                    <div style={{position: 'relative', marginLeft:'20px', height:'fit-content', width:`${props.width * 0.95 - 40}px`, overflow:'auto'}}>
                        <InteractiveValidationTable 
                            colNames={['current factor names', 'please update factor names']}
                            tableRows={validationMessage.factor_name_fixes}
                            inputHandler={handleFactorValidation}
                            onEdit={handleExitValidation}
                            placeholder='Enter factor name ...'
                        />
                    </div>
            </>);
        }
        if(validationMessage.status_objectives !=='ok' ){
            show_validations.push(
                <>
                    <h4 style={{marginLeft:'20px', marginBottom:'10px', marginTop:'25px', padding:'0px'}}>Reponse names need to be defined and unique</h4>
                    <div style={{position: 'relative', marginLeft:'20px', height:'fit-content', width:`${props.width * 0.95 - 40}px`, overflow:'auto'}}>
                        <InteractiveValidationTable 
                            colNames={['current response names', 'please update response names']}
                            tableRows={validationMessage.objective_name_fixes}
                            inputHandler={handleObjectiveValidation}
                            onEdit={handleExitValidation}
                            placeholder='Enter response name ...'
                        />
                    </div>
                </>
            );
        }
        if(validationMessage.status_gonogos !=='ok' && validationMessage.status_factors === 'ok' && validationMessage.status_objectives === 'ok'){
            action_panel = (
                <>
                    <div style={{marginTop:'25px'}}>
                        <div style={{marginLeft:'20px', marginBottom:'5px', fontSize:'14px'}}>Feel free to click 'Exit' to fix inconsistencies directly in Experimental Workflow Editor.</div>
                        <div style={{display:'flex', margin:'0px'}}>
                            <button className={'actionButtonSmall'} style={{marginLeft: '20px', right: '0px', marginBottom:'10px'}} onClick={handleSaveValidationGoNoGo}>Save</button>
                            <button className={'actionButtonSmall'} style={{marginLeft: '0px', right: '0px', marginBottom:'10px'}} onClick={handleExitValidation}>Exit</button>
                        </div>
                    </div>
                </>
                );
            if(no_responses){
                action_panel = (
                    <>
                        <div style={{marginTop:'25px'}}>
                            <div style={{marginLeft:'20px', marginBottom:'5px', fontSize:'14px', color:'red'}}>No responses are defined. Please 'Exit' to fix inconsistencies in Experimental Workflow Editor.</div>
                            <button className={'actionButtonSmall'} style={{marginLeft: '20px', right: '0px', marginBottom:'10px'}} onClick={handleExitValidation}>Exit</button>
                        </div>
                    </>
                    );
            }

            show_validations.push(
                <>
                    <h4 style={{marginLeft:'20px', marginBottom:'10px', marginTop:'25px', padding:'0px'}}>Go/NoGo reponse names need to be defined and valid</h4>
                    <div style={{position: 'relative', marginLeft:'20px', height:'fit-content', width:`${props.width * 0.95 - 40}px`, overflow:'auto'}}>
                        <InteractiveValidationTable 
                            colNames={['current Go/NoGo response names', 'select valid Go/NoGo response']}
                            tableRows={validationMessage.gonogo_name_fixes}
                            inputHandler={handleGoNoGoValidation}
                            selection_options={available_responses}
                        />
                    </div>
                </>);
        }

        editor = (<>
                    <div className = {'builder_canvas'} style={{height:props.height}} >
                        <h3 style={{marginTop:'10px', marginLeft:'20px', marginBottom:'10px', padding:'0px', color:'var(--aixelo-red)'}}>Experimental Workflow Validation</h3>
                        <div style={{marginLeft:'20px', marginBottom:'0px', fontSize:'14px'}}>The following inconsistencies in the provided experimental workflow have been detected.</div>
                        {show_validations}
                        {action_panel}
                    </div>
                </>);
    }


    if(!isLoading && !Exception && !validationWindow){
        if(!showPopup){
            editor = (<>
                        <div className = {'builder_canvas'} style={{height:props.height}} >
                            <h3 style={{marginTop:'10px', marginLeft:'20px', padding:'0px', color:'var(--aixelo-red)'}}>Experimental Workflow Editor</h3>
                            <div style={{display:'flex'}}>
                                <button className={'actionButtonSmall'} style={{marginLeft: '20px', right: '0px', marginBottom:'10px'}} onClick={handleSave}>Save</button>
                                <button className={'actionButtonSmall'} style={{marginLeft: '0px', right: '0px', marginBottom:'10px'}} onClick={handleExit}>Exit</button>
                            </div>
                            <input id='title' style = {{marginLeft:'20px', marginTop: '10px', marginBottom: '10px', border:'none', outline:'none', padding:'5px', position: 'relative',
                                                        borderLeft: '0.5px solid var(--aixelo-gray-light)', fontSize: '24px', fontWeight:'bold', width:'94%'}} 
                                            onChange = {handleTitle} value={title} autoComplete="false" type="text" placeholder="Enter Experimental Setup Title"  name="project_title" />
                            <div style = {{width: `${props.width * 0.95 - 40}px`, marginLeft: '20px', background: 'white', marginTop: '10px', marginBottom: '20px', border:'0.5px solid var(--aixelo-gray-light)'}}>
                                <InfoExperimentalProcedure 
                                    width={props.width*0.95 - 60}
                                    handleDescription={handleQillDescription}
                                    description={descriptionProcedure} />
                            </div>
                            <div style={{display:'flex', alignItems: 'center', marginTop:'10px', marginLeft:'20px'}}>
                                <button className={'plus_button'} style={{fontSize:'20px'}}
                                        onClick={handleCreateSample} >+</button><span style={{fontSize:'18px'}}>create sample</span>
                            </div>
                            <div style={{position: 'relative', marginLeft:'20px', height:'fit-content', width:`${props.width * 0.95 - 40}px`, overflow:'auto'}}>
                                {samples}
                            </div>
                        </div>
                    </>
                    );
        }

        if(showPopup){
            editor = (<>
                <div className = {'builder_canvas'} style={{height:props.height}} >
                    <YesNoPopup ypos={'60px'} handleYes={onYes} handleNo={onNo}>
                        Modifications detected. Exit without saving?
                    </YesNoPopup>  
                </div>
            </>);
        }


        if(showCreateSuccess){
            let uuid_exp_setup = createdObjects.uuid_exp_setup;
            let uuid_design_space = createdObjects.uuid_design_space;
            let uuid_objective = createdObjects.uuid_objective;
            editor = (<>
                <div className = {'builder_canvas'} style={{height:props.height}} >
                    <InfoPopup ypos={'60px'} handleOk={onOkCreate} >
                        Successfully created objects:
                            <div style={{textAlign: 'left'}}>
                                <ul>
                                    <li style={{marginBottom:'5px'}}>ExperimentalSetup (uuid: {uuid_exp_setup})</li>
                                    <li style={{marginBottom:'5px'}}>DesignSpace (uuid: {uuid_design_space})</li>
                                    <li>Objective (uuid: {uuid_objective})</li>
                                </ul>
                       </div>
                    </InfoPopup>  
                </div>
            </>);
        }
        if(showUpdateSuccess){
            editor = (<>
                <div className = {'builder_canvas'} style={{height:props.height}} >
                    <InfoPopup ypos={'60px'} handleOk={onOkUpdate} >
                       Successfully updated objects!
                    </InfoPopup>  
                </div>
            </>);
        }
        if(showNoModificationDetected){
            editor = (<>
                <div className = {'builder_canvas'} style={{height:props.height}} >
                    <InfoPopup ypos={'60px'} handleOk={onOkNoModifications} >
                       All objects are already up to date.
                    </InfoPopup>  
                </div>
            </>);
        }
    }

    return (<>{editor}</>);
}

export default WorkflowEditor